import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useUserRole } from '../../context/UserRoleProvider'

export default function AppRedirect() {
  const navigate = useNavigate()
  const location = useLocation()
  const { isParishAdmin, isSuperAdmin, loading } = useUserRole()

  useEffect(() => {
    // Only redirect if we're actually on the /app index route
    // Don't redirect if user is on a specific page (they should stay there on refresh)
    if (location.pathname !== '/app') {
      return
    }

    if (loading) return

    // Super admins go to admin dashboard
    if (isSuperAdmin) {
      navigate('/app/admin/dashboard', { replace: true })
    } else if (isParishAdmin) {
      // Default to parish admin view for parish admins, but they can switch to donor view
      navigate('/app/parish/profile', { replace: true })
    } else {
      // Donors always go to donor view
      navigate('/app/donor/parish', { replace: true })
    }
  }, [isParishAdmin, isSuperAdmin, loading, navigate, location.pathname])

  return (
    <div className="min-h-screen bg-surface-linen flex items-center justify-center">
      <div className="text-charcoal">Loading...</div>
    </div>
  )
}
